import { render } from "./index.vue?vue&type=template&id=5aafa69e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5aafa69e&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=5aafa69e&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aafa69e"]])

export default __exports__